import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Colour from 'color';
import { ChromePicker } from 'react-color';
import useOnclickOutside from 'react-cool-onclickoutside';
import { BrandTitle } from '../styles';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 0 30px;
`;

const Wrapper = styled.div`
  text-align: left;

  & > input {
    border: 1px solid ${props => props.theme.secondaryColorLight};
    border-radius: 3px;
    outline: none;
  }
`;

const Referee = styled.div`
  & > .chrome-picker {
    position: absolute;
  }
`;
export default function Color({ color, onChange }) {
  const [visible, setVisible] = React.useState(false);
  const ref = useOnclickOutside(() => {
    setVisible(false);
  });

  const onColorChange = ({ hex: value }) => onChange(value);

  const onTextChange = e => {
    let c;
    try {
      c = Colour(e.target.value);
    } catch (err) {
      return;
    }
    onChange(c.rgb().hex().toLowerCase());
  };

  return (
    <Container>
      <BrandTitle>Primary Brand Colour (Optional)</BrandTitle>
      <Wrapper ref={ref}>
        <input value={color} onChange={onTextChange} onClick={() => setVisible(true)} />
        <Referee>
          {visible && <ChromePicker color={color} onChange={onColorChange} disableAlpha />}
        </Referee>
      </Wrapper>
    </Container>
  );
}

Color.propTypes = {
  onChange: PropTypes.func.isRequired,
  color: PropTypes.string,
};

Color.defaultProps = { color: '' };
